"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import FormErrorMessage from "./webflow_modules/Form/components/FormErrorMessage";
import FormForm from "./webflow_modules/Form/components/FormForm";
import FormSuccessMessage from "./webflow_modules/Form/components/FormSuccessMessage";
import FormTextInput from "./webflow_modules/Form/components/FormTextInput";
import FormWrapper from "./webflow_modules/Form/components/FormWrapper";
import { ApartmentSearchPopoverItem } from "./ApartmentSearchPopoverItem";
import { SearchInputClearButton } from "./SearchInputClearButton";
import { SearchInputSearchButton } from "./SearchInputSearchButton";

export function ApartmentSearch({
  children = "",
  clearSearchProps = {},
  searchInputProps = {},
  showClearButton = true,
  showList = true,
}) {
  return (
    <Block className={"search-small-component"} tag={"div"}>
      <FormWrapper className={"form-block"}>
        <FormForm
          data-name={"Email Form 2"}
          id={"email-form-2"}
          method={"get"}
          name={"email-form-2"}
        >
          <Block className={"seach-frame-container"} tag={"div"}>
            <FormTextInput
              autoFocus={false}
              className={"text-field"}
              data-name={"Field"}
              disabled={false}
              id={"field"}
              maxLength={256}
              name={"field"}
              placeholder={"Example Text"}
              required={true}
              type={"text"}
              {...searchInputProps}
            />
            <SearchInputSearchButton />
            <SearchInputClearButton
              clearSearchProps={{
                ...clearSearchProps,
              }}
              showClearButton={showClearButton}
            />
          </Block>
          {showList ? (
            <Block className={"div-block-45"} tag={"div"}>
              <Block className={"search-frame-popover"} tag={"div"}>
                {children ?? (
                  <>
                    <ApartmentSearchPopoverItem />
                    <ApartmentSearchPopoverItem />
                  </>
                )}
              </Block>
            </Block>
          ) : null}
        </FormForm>
        <FormSuccessMessage />
        <FormErrorMessage />
      </FormWrapper>
    </Block>
  );
}
